import CryptoJS from 'crypto-js';
import { CameraModel, HappyCall, HappyCallTemplate, Jisa, Model, UserPwUpdate } from '../type/type';

const url = ``; // setupProxy.js 설정으로 인해 url을 비워둠.

const token_type = 'Bearer';

export const getRandomKey = () => { 
  const array = new Uint8Array(16);
  window.crypto.getRandomValues(array);
  return CryptoJS.lib.WordArray.create(array).toString(CryptoJS.enc.Hex).substring(0, 32);
};

// -------------- SHA-256 해시 함수 (subtleCrypto 사용) --------------
export function encryptSHA256(message: string): string {
  try {
    const encryptMessage = CryptoJS.SHA256(message).toString(CryptoJS.enc.Hex);
    return encryptMessage;
  } catch (error) {
    console.log(error);
    return '';
  }
}
// ------------ SHA-256 해시 함수 (subtleCrypto 사용) 끝 ------------

export function toUrlSafeBase64(base64: string): string {
  return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

// --------------------- AES-256 암/복호화 함수 ---------------------
export function encryptAES256(text: string, key: string, iv: string): string {
  try {
    const encrypted = CryptoJS.AES.encrypt(text, CryptoJS.enc.Utf8.parse(key), {
      iv: CryptoJS.enc.Utf8.parse(iv),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }).toString();
    return encrypted;
  } catch (error) {
    console.log(error);
    return text;
  }
}

// nice 암호화용. aes128
export function encryptAES128(text: string, key: string, iv: string): string {
  if (key.length !== 16) {
    throw new Error('Key length must be 16 bytes for AES-128 encryption.');
  }
  
  try {
    const encrypted = CryptoJS.AES.encrypt(text, CryptoJS.enc.Utf8.parse(key), {
      iv: CryptoJS.enc.Utf8.parse(iv),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }).toString();
    return encrypted;
  } catch (error) {
    console.log(error);
    return text;
  }
}

// nice 암호화용. hmacsha256
export function encryptHmacSha256(text: string, key: string): string {
  try {
    const hmac = CryptoJS.HmacSHA256(text, key).toString();
    return hmac;
  } catch (error) {
    console.log(error);
    return text;
  }
}

export function decryptAES256(encryptedText: string, key: string, iv: string): string {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedText, CryptoJS.enc.Utf8.parse(key),
      {
        iv: CryptoJS.enc.Utf8.parse(iv),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      },
    );
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return decrypted;
  } catch (error) {
    console.log(error);
    return encryptedText;
  }
}


export const authDecryptAes256 = (text: string) => {
  try {
    const AESkey = text.slice(0, 32);
    const iv = AESkey.slice(0, 16);
    const encryptText = text.slice(32);
    if (encryptText.length < 10) return { code: 415 }; // 암호화된 텍스트가 없을 경우도 에러로 처리하도록 추가함.
    
    // 복호화
    const decryptedText = decryptAES256(
      encryptText,
      AESkey,
      iv,
    );
    const timestamp = decryptedText.slice(-10);
    const accessRefreshText = decryptedText.replaceAll(timestamp, '');
    
    const accessRefreshArr = accessRefreshText.split('|');
    const accessToken = accessRefreshArr[0];
    const refreshToken = accessRefreshArr[1];

    return {code : 200, data: [accessToken, refreshToken, timestamp]};
  } catch (error) {
    console.log('authdecryptAES256 error', error);
    return {code : 415};
  }
};

export function textEncryptAes256 (text: string) {
	// 로그인 auth 만들기
	const key = getRandomKey();
	// console.log('key', key);
  const iv = key.slice(0, 16);
  
  const encryptedText = encryptAES256(text, key, iv);

  const result = key + encryptedText;
  return result;
}

export function textDecryptAes256 (text: string) {
  try {
    // AESkey (첫 32자)
    const AESkey = text.slice(0, 32);

    // IV 값 (AESkey 첫 16자)
    const iv = AESkey.slice(0, 16);

    // AES(text) (나머지)
    const encryptedText = text.substring(32);
    const decryptedText = decryptAES256(
      encryptedText,
      AESkey,
      iv,
    );
    return decryptedText;
  } catch (error) {
    console.log('textDecryptAes256 error', error);
    throw error;
  }
};
// --------------------- AES-256 암/복호화 함수 ---------------------

// TOKEN - accessToken으로 로그인 정보 조회
// export async function getLoginInfoByAccessToken(
//   access_token: string,
//   // type: string,
// ): Promise<any> {
//   return await apiRequestHandler(`/v1/token`, 'GET', {
//     access_token,
//   //   type,
//   });
// }



// AGENT - 로그인
export async function agentLogin(auth: string): Promise<any> {
  return await apiRequestHandler(`/v1/agent/login`, 'POST', { auth });
}
// ADMIN - 로그인
export async function adminLogin(auth: string): Promise<any> {
  return await apiRequestHandler(`/v1/admin/login`, 'POST', { auth });
}
// ADMIN - ID로 조회
export async function getAdminById(loginId: string): Promise<any> {
  return await apiRequestHandler(`/v1/admin/id/${loginId}`, 'GET');
}
// ADMIN - ACCESSTOKEN로 조회
export async function getAdminByAccToken(type:string): Promise<any> {
  return await apiRequestHandler(`/v1/admin/token/info/${type}`, 'GET');
}
// ADMIN - ID 중복 CHECK
export async function getAdminDuplicateCheck(loginId: string): Promise<any> {
  return await apiRequestHandler(`/v1/admin/duplicate/${loginId}`, 'GET');
}
// ADMIN - 생성
export async function createAdmin(param: any): Promise<any> {
  return await apiRequestHandler(`/v1/admin`, 'POST', param);
}
// ADMIN - 수정
export async function putAdmin(param: any): Promise<any> {
  return await apiRequestHandler(`/v1/admin/${param.idx}`, 'PUT', param);
}
// ADMIN - 수정
export async function deleteAdmin(adminIdx: number): Promise<any> {
  return await apiRequestHandler(`/v1/admin/${adminIdx}`, 'DELETE');
}
// ADMIN - 모두 조회
export async function getAdminList(pageNo:number | 0, pageSize:number | 0, param?: any): Promise<any> {
  let parameter: string = `?page_no=${pageNo}&page_size=${pageSize}`;
  if (param) {
    const params = new URLSearchParams();
    Object.entries(param).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach(val => params.append(key, val)); // 배열 값을 각각 추가
      } else {
        params.append(key, String(value));
      }
    });

    parameter += `&${params.toString()}`;
  }
  return await apiRequestHandler(`/v1/admin${parameter}`, 'GET');
}


// USER - 관리자페이지에서 고객 임시 비밀번호 발송
export async function sendTempPassword(userId:string): Promise<any> {
  const tempPassword = createTempPassword();
  return await apiRequestHandler(`/v1/user/temp-password/id/${userId}`, 'POST', {password: tempPassword});
}
// USER - 로그인
export async function userLogin(userLoginRequestDto: object): Promise<any> {
  return await apiRequestHandler(
    `/api/user/login`,
    'POST',
    userLoginRequestDto,
  );
}
// USER - 로그인WebTest
export async function userLoginWebTest(
  userLoginRequestDto: object,
): Promise<any> {
  return await apiRequestHandlerNoCredential(`/v1/user/login`, 'POST', userLoginRequestDto);
}
// USER - 사용자 앱 최초 로그인인지 확인
export async function getUserFirstLoginData(): Promise<any> {
  const path = `/v1/user/search/first-login-data`;
  return await apiRequestHandler(path, 'GET');
}

// USER - 사용자 SMS인증 인증번호 발송
export async function sendSmsForVerification(
  data: any,
): Promise<any> {
  return await apiRequestHandler(`/v1/user/sms/verification`, 'POST', data);
}

// USER - 사용자 SMS인증 인증번호 확인
export async function checkSmsVerification(
  data: any,
): Promise<any> {
  return await apiRequestHandler(`/v1/user/sms/verification`, 'PUT', data);
}
// USER - 사용자 SMS인증 인증번호 확인
export async function putAgreeDate(): Promise<any> {
  return await apiRequestHandler(`/v1/user/agree/verification`, 'PUT', null);
}

// USER - 비밀번호 찾기 후 비밀번호 변경
export async function updatePwByFindPw(data: UserPwUpdate): Promise<any> {
  return await apiRequestHandler(`/v1/user/update/pw/find`, 'PUT', data);
}
// USER - 사용자 내정보 수정
export async function updateUserInfo(user: any):Promise<any> {
  return await apiRequestHandler(`/v1/user/update/info`, 'PUT', user);
}

// USER - 생성
export async function createUser(user: any):Promise<any> {
  return await apiRequestHandler(`/v1/user`, 'POST', user);
}
// USER - 수정
export async function putUser(user: any):Promise<any> {
  return await apiRequestHandler(`/v1/user/${user.idx}`, 'PUT', user);
}
// USER - 최초 로그인 시 회원정보 수정
export async function putFirstLoginUser(user: any):Promise<any> {
  return await apiRequestHandler(`/v1/user/first/${user.idx}`, 'PUT', user);
}
// USER - ID로 조회
export async function getUserById(loginId: string):Promise<any> {
  return await apiRequestHandler(`/v1/user/id/${loginId}`, 'GET');
}
// USER - accesstoken으로 조회
export async function getUserByAccToken():Promise<any> {
  return await apiRequestHandler(`/v1/user/find/token`, 'GET');
}
// USER - 계약번호로 조회
export async function getUserByContractNo(contractNo: string):Promise<any> {
  return await apiRequestHandler(`/v1/user/contract-no/${contractNo}`, 'GET');
}
// USER - 모두 조회
export async function getUserList(pageNo:number | 0, pageSize:number | 0, param?: any):Promise<any> {
  let parameter: string = `?page_no=${pageNo}&page_size=${pageSize}`;
  if (param) {
    const params = new URLSearchParams();
    Object.entries(param).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach(val => params.append(key, val)); // 배열 값을 각각 추가
      } else {
        params.append(key, String(value));
      }
    });

    parameter += `&${params.toString()}`;
  }
  return await apiRequestHandler(`/v1/user${parameter}`, 'GET');
}
// USER - EVENT PAGE에서만 사용 (TOKEN없어도 사용 가능하도록)
export async function getUserListForEvent(encMac: string):Promise<any> {
  return await apiRequestHandler(`/v1/user/event/${encMac}`, 'GET');
}
// USER - 탈퇴
export async function deleteUser(userIdx: number):Promise<any> {
  return await apiRequestHandler(`/v1/user/${userIdx}`, 'DELETE');
}
// USER - 대원 APP에서 호출
export async function getSearchUserList(param: any):Promise<any> {
  let parameter: string = `?type=Agent`;
  if (param) {
    parameter += `&${new URLSearchParams(param).toString()}`;
  }
  return await apiRequestHandler(`/v1/user/search/users${parameter}`, 'GET');
}
// USER - 아이디 체크
export async function checkUserId(data: any):Promise<any> {
  return await apiRequestHandler(`/v1/user/check/id`, 'POST', data);
}
// USER - 비밀번호 체크
export async function checkUserPw(data: any):Promise<any> {
  return await apiRequestHandler(`/v1/user/check/pw`, 'POST', data);
}

// USER - 계약번호로 조회
export async function getUserContractByContractNo(contractNo: string):Promise<any> {
  return await apiRequestHandler(`/v1/user-contract/no/${contractNo}`, 'GET');
}

// 고객 ID 중복 체크 (USER, SUB USER)
export async function getIdDuplicateCheck(id: string):Promise<any> {
  return await apiRequestHandler(`/v1/user/duplicate-check/id/${id}`, 'GET');
}

// SUB USER - 모두 조회
export async function getSubUserList(pageNo:number | 0, pageSize:number | 0, param?: any):Promise<any> {
  let parameter: string = `?page_no=${pageNo}&page_size=${pageSize}`;
  if (param) {
    const params = new URLSearchParams();
    Object.entries(param).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach(val => params.append(key, val)); // 배열 값을 각각 추가
      } else {
        params.append(key, String(value));
      }
    });

    parameter += `&${params.toString()}`;
  }
  return await apiRequestHandler(`/v1/sub-user${parameter}`, 'GET');
}
// SUB USER - accesstoken으로 조회
export async function getSubUserByAccToken():Promise<any> {
  return await apiRequestHandler(`/v1/sub-user/find/token`, 'GET');
}
// SUB USER - IDX로 조회
export async function getSubUserByIdx(idx: number):Promise<any> {
  return await apiRequestHandler(`/v1/sub-user/${idx}`, 'GET');
}
// SUB USER - ID로 조회
export async function getSubUserById(id: string):Promise<any> {
  return await apiRequestHandler(`/v1/sub-user/id/${id}`, 'GET');
}
// SUB USER - 생성/수정
export async function upsertSubUser(subUser: any):Promise<any> {
  return await apiRequestHandler(`/v1/sub-user`, 'POST', subUser);
}
// SUB USER - 수정
export async function updateSubUser(subUser: any):Promise<any> {
  return await apiRequestHandler(`/v1/sub-user`, 'PUT', subUser);
}
// SUB USER - 첫로그인 PWD 변경
export async function editSubUserFirst(subUser: any):Promise<any> {
  return await apiRequestHandler(`/v1/sub-user/first/${subUser.idx}`, 'PUT', subUser);
}
// SUB USER - 삭제
export async function deleteSubUser(idx: number):Promise<any> {
  return await apiRequestHandler(`/v1/sub-user/${idx}`, 'DELETE');
}
// SUB USER - PUSH 수정
export async function updateSubUserPush(subUserPush: any):Promise<any> {
  return await apiRequestHandler(`/v1/sub-user/push`, 'PUT', subUserPush);
}
// SUB RECORDER - PUSH 수정
export async function updateSubRecorderOne(subRecorder: any):Promise<any> {
  return await apiRequestHandler(`/v1/sub-recorder/${subRecorder.idx}`, 'POST', subRecorder);
}

// Contract - 생성
export async function createContract(contract: any):Promise<any> {
  return await apiRequestHandler(`/v1/contract`, 'POST', contract);
}
// Contract - 수정
export async function putContract(contract: any):Promise<any> {
  return await apiRequestHandler(`/v1/contract/${contract.idx}`, 'PUT', contract);
}
// Contract - 삭제
export async function deleteContract(idx: any):Promise<any> {
  return await apiRequestHandler(`/v1/contract/${idx}`, 'DELETE');
}
// Contract - idx로 조회
export async function getContractByIdx(idx: number):Promise<any> {
  return await apiRequestHandler(`/v1/contract/${idx}`, 'GET');
}
// Contract - 계약번호로 조회
export async function getContractByNo(contractNo: string):Promise<any> {
  return await apiRequestHandler(`/v1/contract/no/${contractNo}`, 'GET');
}
// Contract - 계약번호로 조회 (관리자 지사로 조회 되도록 수정)
export async function getAdminContractByNo(contractNo: string):Promise<any> {
  return await apiRequestHandler(`/v1/contract/admin/no/${contractNo}`, 'GET');
}
// Contract - 모두 조회
export async function getContractList(pageNo: number|0, pageSize: number|0, param?: any):Promise<any> {
  let parameter: string = `?page_no=${pageNo}&page_size=${pageSize}`;
  if (param) {
    const params = new URLSearchParams();
    Object.entries(param).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach(val => params.append(key, val)); // 배열 값을 각각 추가
      } else {
        params.append(key, String(value));
      }
    });

    parameter += `&${params.toString()}`;
  }
  return await apiRequestHandler(`/v1/contract${parameter}`, 'GET');
}

// ContractProductCount - 생성
export async function createContractProductCount(contractProductCount: any):Promise<any> {
  return await apiRequestHandler(`/v1/contract-product-count`, 'POST', contractProductCount);
}
// ContractProductCount - 수정
export async function setContractProductCount(contractProductCount: any):Promise<any> {
  return await apiRequestHandler(`/v1/contract-product-count/${contractProductCount.idx}`, 'PUT', contractProductCount);
}
// ContractProductCount - idx로 조회
export async function getContractProductCountOne(idx: number):Promise<any> {
  return await apiRequestHandler(`/v1/contract-product-count/${idx}`, 'GET');
}
// ContractProductCount - 모두 조회
export async function getContractProductCountList():Promise<any> {
  return await apiRequestHandler(`/v1/contract-product-count`, 'GET');
}



// RECORDER - 최종 생성
export async function createRecorder(recorder: any):Promise<any> {
  return await apiRequestHandler(`/v1/recorder`, 'POST', recorder);
}
// RECORDER - 1차 개통
export async function prevCreateRecorder(recorder: any):Promise<any> {
  return await apiRequestHandler(`/v1/recorder/prev`, 'POST', recorder);
}
// RECORDER - 내부복사 생성
export async function createInCopyRecorder(inCopyRecorder: any):Promise<any> {
  return await apiRequestHandler(`/v1/recorder/in-copy`, 'POST', inCopyRecorder);
}
// RECORDER - 수정
export async function putRecorder(recorder: any):Promise<any> {
  return await apiRequestHandler(`/v1/recorder/${recorder.idx}`, 'PUT', recorder);
}
// RECORDER - 교체
export async function replaceRecorder(recorder: any):Promise<any> {
  return await apiRequestHandler(`/v1/recorder/replace`, 'POST', recorder);
}
// RECORDER - IDX로 조회
export async function getRecorderByIdx(idx: number):Promise<any> {
  return await apiRequestHandler(`/v1/recorder/${idx}`, 'GET');
}
// RECORDER - 계약번호로 조회
export async function getRecorderByContractNo(contractNo: string):Promise<any> {
  return await apiRequestHandler(`/v1/recorder/contract/${contractNo}`, 'GET');
}
// RECORDER - MAC 중복 CHECK
export async function getRecorderDuplicateCheck(mac: string): Promise<any> {
  return await apiRequestHandler(`/v1/recorder/duplicate/${mac}`, 'GET');
}
// RECORDER - uuid 생성 및 전달
export async function postUuidAndSend(recorder: any): Promise<any> {
  return await apiRequestHandler(`/v1/recorder/uuid/send`, 'POST', recorder);
}
// RECORDER - 모두 조회
export async function getRecorderList(pageNo: number|0, pageSize: number|0, param?: any):Promise<any> {
  let parameter: string = `?page_no=${pageNo}&page_size=${pageSize}`;
  if (param) {
    parameter += `&${new URLSearchParams(param).toString()}`;
  }
  return await apiRequestHandler(`/v1/recorder${parameter}`, 'GET');
}
// RECORDER - IDX로 삭제
export async function deleteRecorderByIdx(idx: number):Promise<any> {
  return await apiRequestHandler(`/v1/recorder/${idx}`, 'DELETE');
}
// RECORDER - 교체가능한 장비인지 확인
export async function replaceCheck(idx: number):Promise<any> {
  return await apiRequestHandler(`/v1/recorder/repalce-check/${idx}`, 'GET');
}


// HEALTH 서버 - MAC 삭제
export async function deleteRecorderHealthByMac(mac: string):Promise<any> {
  return await apiRequestHandler(`/v1/health`, 'DELETE', { mac });
}
// HEALTH 서버 - MAC으로 조회
export async function getRecorderHealthByMac(mac: string):Promise<any> {
  return await apiRequestHandler(`/v1/health/mac/${mac}`, 'GET');
}


// 공지사항 전체/단건 조회
export async function getNoticeAll(pageNo: number | 0, pageSize: number | 0, param?: any): Promise<any> {
  let parameter: string = `?page_no=${pageNo}&page_size=${pageSize}`;
  if (param) {
    parameter += `&${new URLSearchParams(param).toString()}`;
  }
  return await apiRequestHandler(`/v1/notice${parameter}`, "GET");
}
export async function getNoticeOne(noticeIdx?: number): Promise<any> {
  return await apiRequestHandler(`/v1/notice/${noticeIdx}`, "GET");
}
// 공지사항 등록
export async function createNotice(notice: any): Promise<any> {
  return await formDataApiRequestHandler(`/v1/notice`, 'POST', notice);
}
// 공지사항 수정
export async function putNotice(noticeIdx: number, notice: any): Promise<any> {
  return await formDataApiRequestHandler(`/v1/notice/${noticeIdx}`, 'PUT', notice);
}
// 공지사항 삭제
export async function deleteNotice(noticeIdx: number): Promise<any> {
  return await apiRequestHandler(`/v1/notice/${noticeIdx}`,"DELETE");
}


// AS 전체 조회
export async function getAfterServiceAll(pageNo: number | 0, pageSize: number | 0, param?: any): Promise<any> {
  let parameter: string = `?page_no=${pageNo}&page_size=${pageSize}`;
  if (param) {
    parameter += `&${new URLSearchParams(param).toString()}`;
  }
  return await apiRequestHandler(`/v1/as${parameter}`, "GET");
}
// AS 단건 조회
export async function getAfterServiceOne(asIdx?: number): Promise<any> {
  return await apiRequestHandler(`/v1/as/${asIdx}`, "GET");
}
// AS 등록
export async function createAfterService(as: any): Promise<any> {
  return await apiRequestHandler(`/v1/as`, 'POST', as);
}
// AS 수정
export async function putAfterService(as: any): Promise<any> {
  return await apiRequestHandler(`/v1/as/${as.idx}`, 'PUT', as);
}
// AS 진행상황 수정
export async function updateAfterServiceState(as: any): Promise<any> {
  return await apiRequestHandler(`/v1/as/state/${as.idx}`, 'PUT', as);
}
// AS 삭제
export async function deleteAfterService(asIdx: number): Promise<any> {
  return await apiRequestHandler(`/v1/as/${asIdx}`,"DELETE");
}
// AS 답변 등록
export async function upsertAfterServiceAnswer(asAnswer: any): Promise<any> {
  return await apiRequestHandler(`/v1/as-answer`, 'POST', asAnswer);
}


// RECORDER EVENTS 녹화기 이벤트 MAC으로 조회
export async function getRecorderEventsByMac(mac: string): Promise<any> {
  return await apiRequestHandler(`/v1/recorder-events/mac/${mac}`, "GET");
}

// RECORDER EVENTS 녹화기 이벤트 MAC으로 조회
export async function getUserAndEvents(param: any): Promise<any> {
  const parameter: string = `?${new URLSearchParams(param).toString()}`;
  return await apiRequestHandler(`/v1/viewer${parameter}`, "GET");
}

// 녹화기 이벤트 서버 이벤트 모두 조회
export async function getRecorderDdnsEvent(pageNo: number | 0, pageSize: number | 0, param?: any): Promise<any> {
  let parameter: string = `?page_no=${pageNo}&page_size=${pageSize}`;
  if (param) {
    parameter += `&${new URLSearchParams(param).toString()}`;
  }
  return await apiRequestHandler(`/v1/ddns/event${parameter}`, "GET");
}

// 녹화기 이벤트 서버 단건 조회
export async function getRecorderDdnsEventOne(idx: number, tableName: string): Promise<any> {
  return await apiRequestHandler(`/v1/ddns/event/${tableName}/${idx}`, "GET");
}


// LocalStorage 삭제
export function removeLocalStorage() {
  localStorage.removeItem(ACCESS_TOKEN_NAME);
  localStorage.removeItem(REFRESH_TOKEN_NAME);
  localStorage.removeItem(TYPE);
}


// JISA - 전체 조회
export async function getJisaAll(pageNo: number | 0, pageSize: number | 0, param?: any): Promise<any> {
  let parameter: string = `?page_no=${pageNo}&page_size=${pageSize}`;
  if (param) {
    parameter += `&${new URLSearchParams(param).toString()}`;
  }
  return await apiRequestHandler(`/v1/jisa${parameter}`, "GET");
}
// JISA - 단건 조회
export async function getJisaOne(jisaIdx: number): Promise<any> {
  return await apiRequestHandler(`/v1/jisa/${jisaIdx}`, "GET");
}
// JISA - 등록
export async function postJisa(jisa: Jisa): Promise<any> {
  return await apiRequestHandler(`/v1/jisa`, "POST", jisa);
}
// JISA - 수정
export async function putJisa(jisa: Jisa): Promise<any> {
  return await apiRequestHandler(`/v1/jisa/${jisa.idx}`, "PUT", jisa);
}
// JISA - 삭제
export async function deleteJisa(jisaIdx: number): Promise<any> {
  return await apiRequestHandler(`/v1/jisa/${jisaIdx}`, "DELETE");
}


// RECORDER MODEL - 전체 조회
export async function getModelAll(pageNo: number | 0, pageSize: number | 0, param?: any): Promise<any> {
  let parameter: string = `?page_no=${pageNo}&page_size=${pageSize}`;
  if (param) {
    parameter += `&${new URLSearchParams(param).toString()}`;
  }
  return await apiRequestHandler(`/v1/model${parameter}`, "GET");
}
// RECORDER MODEL - IDX 단건 조회
export async function getModelOne(recorderModelIdx: number): Promise<any> {
  return await apiRequestHandler(`/v1/model/${recorderModelIdx}`, "GET");
}
// RECORDER MODEL - 이름 단건 조회
export async function getModelByName(recorderModelName: string): Promise<any> {
  return await apiRequestHandler(`/v1/model/name/${recorderModelName}`, "GET");
}
// RECORDER MODEL - 등록
export async function postModel(recorderModel: Model): Promise<any> {
  return await apiRequestHandler(`/v1/model`, "POST", recorderModel);
}
// RECORDER MODEL - 수정
export async function putModel(recorderModel: Model): Promise<any> {
  return await apiRequestHandler(`/v1/model/${recorderModel.idx}`, "PUT", recorderModel);
}
// RECORDER MODEL - 삭제
export async function deleteModel(recorderModelIdx: number): Promise<any> {
  return await apiRequestHandler(`/v1/model/${recorderModelIdx}`, "DELETE");
}


// CAMERA MODEL - 전체 조회
export async function getCameraModelAll(pageNo: number | 0, pageSize: number | 0, param?: any): Promise<any> {
  let parameter: string = `?page_no=${pageNo}&page_size=${pageSize}`;
  if (param) {
    parameter += `&${new URLSearchParams(param).toString()}`;
  }
  return await apiRequestHandler(`/v1/camera-model${parameter}`, "GET");
}
// CAMERA MODEL - 단건 조회
export async function getCameraModelOne(cameraModelIdx: number): Promise<any> {
  return await apiRequestHandler(`/v1/camera-model/${cameraModelIdx}`, "GET");
}
// CAMERA MODEL - 등록
export async function postCameraModel(cameraModel: CameraModel): Promise<any> {
  return await apiRequestHandler(`/v1/camera-model`, "POST", cameraModel);
}
// CAMERA MODEL - 수정
export async function putCameraModel(cameraModel: CameraModel): Promise<any> {
  return await apiRequestHandler(`/v1/camera-model/${cameraModel.idx}`, "PUT", cameraModel);
}
// CAMERA MODEL - 삭제
export async function deleteCameraModel(cameraModelIdx: number): Promise<any> {
  return await apiRequestHandler(`/v1/camera-model/${cameraModelIdx}`, "DELETE");
}


// HAPPY CALL - 전체 조회
export async function getHappyCallAll(pageNo: number | 0, pageSize: number | 0, param?: any): Promise<any> {
  let parameter: string = `?page_no=${pageNo}&page_size=${pageSize}`;
  if (param) {
    parameter += `&${new URLSearchParams(param).toString()}`;
  }
  return await apiRequestHandler(`/v1/happy-call${parameter}`, "GET");
}
// HAPPY CALL - 단건 조회
export async function getHappyCallOne(happyCallIdx: number): Promise<any> {
  return await apiRequestHandler(`/v1/happy-call/${happyCallIdx}`, "GET");
}
// HAPPY CALL - 등록
export async function postHappyCall(happyCallModel: HappyCall): Promise<any> {
  return await apiRequestHandler(`/v1/happy-call`, "POST", happyCallModel);
}

// HAPPY CALL TEMPLATE - 전체 조회
export async function getHappyCallTemplateAll(pageNo: number | 0, pageSize: number | 0, param?: any): Promise<any> {
  let parameter: string = `?page_no=${pageNo}&page_size=${pageSize}`;
  if (param) {
    parameter += `&${new URLSearchParams(param).toString()}`;
  }
  return await apiRequestHandler(`/v1/happy-call-template${parameter}`, "GET");
}

// HAPPY CALL - 단건 조회
export async function getHappyCallTemplateOne(happyCallTemplateIdx: number): Promise<any> {
  return await apiRequestHandler(`/v1/happy-call-template/${happyCallTemplateIdx}`, "GET");
}

// HAPPY CALL TEMPLATE - 등록
export async function postHappyCallTemplate(happyCallTemplate: HappyCallTemplate): Promise<any> {
  return await apiRequestHandler(`/v1/happy-call-template`, "POST", happyCallTemplate);
}

// HAPPY CALL TEMPLATE - 수정
export async function putHappyCallTemplate(happyCallTemplate: HappyCallTemplate): Promise<any> {
  return await apiRequestHandler(`/v1/happy-call-template`, "PUT", happyCallTemplate);
}

// HAPPY CALL TEMPLATE - 삭제
export async function deleteHappyCallTemplate(happyCallTemplateIdx: number): Promise<any> {
  return await apiRequestHandler(`/v1/happy-call-template/${happyCallTemplateIdx}`, "DELETE");
}

// NICE - 암호화 토큰 발급
export async function createCryptoTokenNice(data: object):Promise<any> {
  const result = await apiRequestHandler(`/api/nice/cryptotoken`,"POST", data);
  return result;
}

export async function sendNvrApi(data: any) {
  // const data = {
  //   site: {
  //     site_userId: '',
  //     site_password: '',
  //     site_ip: '192.168.41.179',
  //     site_web_port: 81,
  //     site_uri: '/api/authCmd',
  //     site_method: 'POST',
  //   },
  //   sendData: {
  //     command: 'getJpegImage',
  //     data: {
  //       channel: 6,
  //       time: '2022-01-04T11:14:12.000'
  //     },
  //   },
  // };
  const result = await apiRequestHandler(`/v1/viewer`,"POST", data);
  return result;
}

//API 요청 함수
async function apiRequestHandler(path:string, method:string, body?:any):Promise<ResponseData>{
  try{
    const response = await fetch(`${url}${path}`,{
    method: method,
    headers: {
      "Content-Type": "application/json",
      [TYPE]: localStorage.getItem(TYPE) || "",
      // authorization header에 access token을 넣어준다.
      [ACCESS_TOKEN_HEADER]: token_type + ' ' + localStorage.getItem(ACCESS_TOKEN_NAME) || "",
      // 
      [REFRESH_TOKEN_NAME]: token_type + ' ' + localStorage.getItem(REFRESH_TOKEN_NAME) || "",
    },
      credentials: "include",
      body: body? JSON.stringify(body) : null
    });

    const result: ResponseData = await response.json();
    // 로그인 및 토큰 갱신 시 localStorage에 저장
    await checkHeaders(response, result, path);

    return result;
  }
  catch(err){
    console.log("request Call Error", err);

    // 특정 에러로 인해 throw된 경우는 리다이렉트 후 반환하지 않음
    if ((err as Error).message === "Authentication error") {
      // 리다이렉트 후에는 아무 동작도 하지 않음
      return new Promise(() => {}); // Promise를 영구적으로 대기 상태로 설정
    }

    return {code:500, message: "서버와의 통신에 문제가 발생했습니다. 잠시 후 다시 시도해주세요."};
  }
}

//API 요청 함수
async function apiRequestHandlerNoCredential(path:string, method:string, body?:any):Promise<ResponseData>{
  try{
    const response = await fetch(`${url}${path}`,{
      method: method,
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "omit",
      body: JSON.stringify(body)
    });
    const result: ResponseData = await response.json();

    // 로그인 및 토큰 갱신 시 localStorage에 저장
    await checkHeaders(response, result, path);

    return result;
  }
  catch(err){
    console.log("request Call Error", err);
    return {code:500, message: "서버와의 통신에 문제가 발생했습니다. 잠시 후 다시 시도해주세요."};
  }
}


export function generateSecureRandomString(length = 32) {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  const randomValues = new Uint8Array(length);
  crypto.getRandomValues(randomValues);

  return Array.from(randomValues)
    .map((value) => characters[value % charactersLength])
    .join('');
}

export function createTempPassword(length = 6) {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  const charactersLength = characters.length;
  const randomValues = new Uint8Array(length);
  crypto.getRandomValues(randomValues);

  return Array.from(randomValues)
    .map((value) => characters[value % charactersLength])
    .join('');
}

// formData용 API 요청 함수
async function formDataApiRequestHandler(path:string, method:string, body?:any):Promise<ResponseData>{
  try{
    const response = await fetch(`${url}${path}`,{
      method: method,
      headers: {
      [TYPE]: localStorage.getItem(TYPE) || "",
      // authorization header에 access token을 넣어준다.
      [ACCESS_TOKEN_HEADER]: token_type + ' ' + localStorage.getItem(ACCESS_TOKEN_NAME) || "",
      [REFRESH_TOKEN_NAME]: token_type + ' ' + localStorage.getItem(REFRESH_TOKEN_NAME) || "",
      },
      credentials: "include",
      body: body,
    });
    const result: ResponseData = await response.json();

    // 로그인 및 토큰 갱신 시 localStorage에 저장
    await checkHeaders(response, result, path);

    return result;
  }
  catch(err){
    console.log("request Call Error", err);
    // alert("서버와의 통신에 문제가 발생했습니다. 잠시 후 다시 시도해주세요.");
    return {code:500, message: "서버와의 통신에 문제가 발생했습니다. 잠시 후 다시 시도해주세요."};
  }
}

export function maxLengthCheck(event: any){
  const target = event.currentTarget;
  const maxLen = target.maxLength || 0;

  if (maxLen && target.value.length > maxLen) {
    target.value = target.value.slice(0, target.maxLength);
  }  
}

export function maskMobile(mobile: string): string {
  // 정규식으로 '010'으로 시작하는 10~11자리 숫자 확인
  if (!/^01[016789]\d{3,4}\d{4}$/.test(mobile)) {
    console.error("올바른 휴대폰 번호 형식이 아닙니다.");
    return mobile;
  }

  const prefix = mobile.slice(0, 3); // 앞자리 '010'
  const suffix = mobile.slice(-4); // 뒷자리 4자리
  const mask = mobile.length === 11 ? "****" : "***"; // 길이에 따라 마스킹 처리

  return `${prefix}-${mask}-${suffix}`;
};
export function addHyphenMobile(mobile: string): string {
  // 정규식으로 '010'으로 시작하는 10~11자리 숫자 확인
  if (!/^01[016789]\d{3,4}\d{4}$/.test(mobile)) {
    console.error("올바른 휴대폰 번호 형식이 아닙니다.");
    return mobile;
  }

  const prefix = mobile.slice(0, 3); // 앞자리 '010'
  const midfix = mobile.length === 11 ? mobile.slice(3, 7) : mobile.slice(3, 6); // 길이에 따라 중간 번호 추출
  const suffix = mobile.slice(-4); // 뒷자리 4자리

  return `${prefix}-${midfix}-${suffix}`;
};

// 계약 상태 확인
export function getContractStatusValid(status: string) {
  //A: 대기, B: 승인, C: 계약중, D: 중지, E: 해약, F: 만료
  const validStatus = ['B', 'C'];
  return validStatus.includes(status);
}

//헤더 정보 저장
export function setHeaders(accessToken: string, refreshToken: string, type: string) {
  if(accessToken) localStorage.setItem(ACCESS_TOKEN_NAME, accessToken);
  if(refreshToken) localStorage.setItem(REFRESH_TOKEN_NAME, refreshToken);
  if(type) localStorage.setItem(TYPE, type);
}

//헤더 확인 후 저장
export async function checkHeaders(response: any, result: ResponseData, path: string) {
  const type = response.headers.get(TYPE) ?? localStorage.getItem(TYPE) ?? '';

  const newAccessToken = response.headers.get(ACCESS_TOKEN_HEADER);
  const newRefreshToken = response.headers.get(REFRESH_TOKEN_NAME);

  if (newAccessToken && newRefreshToken) {
    // console.log("Token localStorage 저장 완료");
    return setHeaders(
      newAccessToken.startsWith('Bearer ') ? newAccessToken.slice(7) : newAccessToken,
      newRefreshToken.startsWith('Bearer ') ? newRefreshToken.slice(7) : newRefreshToken,
      type
    );
  }

  // 기존 accessToken, refreshToken이 없고, 401 또는 452 오류 발생 시 로그인 페이지로 이동
  const accessToken = localStorage.getItem(ACCESS_TOKEN_NAME);
  const refreshToken = localStorage.getItem(REFRESH_TOKEN_NAME);

  if (!accessToken || !refreshToken || result.code === 401 || result.code === 452) {
    removeLocalStorage();
    if (type === "Admin") {
      alert("로그인 정보가 만료되었거나 유효하지 않습니다. 다시 로그인 해주세요.");
      window.location.href = "/admin/login";
    } else if (type === "Agent") {
      // logout();
    } else if (type === "User") {
      // userLogout();
    } else {
      // TODO 프로세스 필요
    }
  }
}

export function isMobile(): boolean {
  const userAgent = navigator.userAgent.toLowerCase();
  const mobileDevices = [
    'iphone',
    'ipad',
    'blackberry',
    'android',
    'windows ce',
    'lg',
    'mot',
    'samsung',
    'sonyericsson',
    'nokia',
    'webos',
    'opera mini',
    'opera mobi',
    'iemobile',
    'macintosh', // 이건 필요시 제거 가능
  ];

  return mobileDevices.some(device => userAgent.includes(device));
}

//서버 API 응답 데이터 모델
interface ResponseData {
  code: number;
  message: string;
  data?: any;
  total_count?:number;
}

//로그인 header 정보
export const ACCESS_TOKEN_HEADER = 'authorization'; // access_token은 이 헤더에 담는다.
export const ACCESS_TOKEN_NAME = 'access-token'; // localStorage에는 이 키로 저장한다.
export const REFRESH_TOKEN_NAME = 'refresh-token'; // localStorage에는 이 키로 저장한다. refresh_token은 이 헤더에 담는다.
export const TYPE = 'type'; // 앱 종류 (Agent, Admin, User)